"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RugbyUnionPeriodName;
(function (RugbyUnionPeriodName) {
    RugbyUnionPeriodName["pregame"] = "Pre Game";
    RugbyUnionPeriodName["regularFirstHalf"] = "First Half";
    RugbyUnionPeriodName["regularHalfTime"] = "Half Time";
    RugbyUnionPeriodName["regularSecondHalf"] = "Second Half";
    RugbyUnionPeriodName["regularTimeFinished"] = "End of Regular Time";
    RugbyUnionPeriodName["extraTimeFirstHalf"] = "Extra Time - 1st Half";
    RugbyUnionPeriodName["extraTimeHalfTime"] = "Extra Time - Break";
    RugbyUnionPeriodName["extraTimeSecondHalf"] = "Extra Time - 2nd Half";
    RugbyUnionPeriodName["extraTimeFinished"] = "Extra Time Finished";
    RugbyUnionPeriodName["shootOut"] = "Kicking Comp";
    RugbyUnionPeriodName["matchFinishedReg"] = "Full Time";
    RugbyUnionPeriodName["matchFinishedExtraTime"] = "Full Time";
})(RugbyUnionPeriodName = exports.RugbyUnionPeriodName || (exports.RugbyUnionPeriodName = {}));
var RugbyUnionPeriodShortName;
(function (RugbyUnionPeriodShortName) {
    RugbyUnionPeriodShortName["pregame"] = "Pre Game";
    RugbyUnionPeriodShortName["regularFirstHalf"] = "1st Half";
    RugbyUnionPeriodShortName["regularHalfTime"] = "Half Time";
    RugbyUnionPeriodShortName["regularSecondHalf"] = "2nd Half";
    RugbyUnionPeriodShortName["regularTimeFinished"] = "Regular Time";
    RugbyUnionPeriodShortName["extraTimeFirstHalf"] = "ET - 1st";
    RugbyUnionPeriodShortName["extraTimeHalfTime"] = "ET - Break";
    RugbyUnionPeriodShortName["extraTimeSecondHalf"] = "ET - 2nd";
    RugbyUnionPeriodShortName["extraTimeFinished"] = "Full Time - ET";
    RugbyUnionPeriodShortName["shootOut"] = "Kicking Comp";
    RugbyUnionPeriodShortName["matchFinishedReg"] = "Full Time";
    RugbyUnionPeriodShortName["matchFinishedExtraTime"] = "Full Time - KC";
    RugbyUnionPeriodShortName["matchCancelled"] = "Cancelled";
})(RugbyUnionPeriodShortName = exports.RugbyUnionPeriodShortName || (exports.RugbyUnionPeriodShortName = {}));
var RugbyUnionPeriodCode;
(function (RugbyUnionPeriodCode) {
    RugbyUnionPeriodCode["pregame"] = "pregame";
    RugbyUnionPeriodCode["regularFirstHalf"] = "regularFirstHalf";
    RugbyUnionPeriodCode["regularHalfTime"] = "regularHalfTime";
    RugbyUnionPeriodCode["regularSecondHalf"] = "regularSecondHalf";
    RugbyUnionPeriodCode["regularTimeFinished"] = "regularTimeFinished";
    RugbyUnionPeriodCode["extraTimeFirstHalf"] = "extraTimeFirstHalf";
    RugbyUnionPeriodCode["extraTimeHalfTime"] = "extraTimeHalfTime";
    RugbyUnionPeriodCode["extraTimeSecondHalf"] = "extraTimeSecondHalf";
    RugbyUnionPeriodCode["extraTimeFinished"] = "extraTimeFinished";
    RugbyUnionPeriodCode["shootOut"] = "shootOut";
    RugbyUnionPeriodCode["matchFinishedReg"] = "matchFinishedReg";
    RugbyUnionPeriodCode["matchFinishedExtraTime"] = "matchFinishedExtraTime";
})(RugbyUnionPeriodCode = exports.RugbyUnionPeriodCode || (exports.RugbyUnionPeriodCode = {}));
//# sourceMappingURL=Periods.js.map